import React from "react";
import { HiOutlineDocumentText, HiOutlinePhotograph, HiOutlineVideoCamera, HiOutlineMicrophone, HiOutlineArrowNarrowRight } from "react-icons/hi";

const RightSide = () => {
  const publishOptions = [
    { icon: <HiOutlineDocumentText size={20} />, title: "Text Post", description: "Share thoughts, stories, and updates", bg: "bg-purple-50", color: "text-purple-600" },
    { icon: <HiOutlineVideoCamera size={20} />, title: "Video Post", description: "Upload one or multiple videos", bg: "bg-blue-50", color: "text-blue-600" },
    { icon: <HiOutlinePhotograph size={20} />, title: "Photo Post", description: "Share single or multiple photos", bg: "bg-emerald-50", color: "text-emerald-600" },
    { icon: <HiOutlineMicrophone size={20} />, title: "Voice Post", description: "Record and publish audio", bg: "bg-orange-50", color: "text-orange-600" },
  ];

  return (
    <aside className="sticky top-[72px] hidden h-[calc(100dvh-72px)] w-[320px] shrink-0 border-l border-gray-100 bg-white xl:flex xl:flex-col">
      <div className="flex h-full min-h-0 flex-col px-5 py-5">
        {/* HEADER */}

        <div className="shrink-0">
          <span className="inline-flex items-center rounded-full bg-purple-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-purple-600">
            Create
          </span>

          <h2 className="mt-2.5 text-lg font-bold leading-[1.3] tracking-tight text-gray-900">
            Share something on Pinokyo
          </h2>

          <p className="mt-1.5 text-xs leading-5 text-gray-500">
            Choose how you want to connect with your community.
          </p>
        </div>

        {/* DIVIDER */}

        <div className="my-4 border-t border-gray-100" />

        {/* PUBLISH OPTIONS */}

        <div className="shrink-0 space-y-1.5">
          {publishOptions.map((item) => (
            <button key={item.title} type="button" className="group flex w-full items-center gap-3 rounded-xl border border-transparent px-2.5 py-2.5 text-left transition-all duration-200 hover:border-gray-100 hover:bg-gray-50">
              <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${item.bg} ${item.color} transition-transform duration-200 group-hover:scale-105`}>
                {item.icon}
              </div>

              <div className="min-w-0 flex-1">
                <h3 className="text-[13px] font-semibold text-gray-900 transition-colors group-hover:text-purple-700">
                  {item.title}
                </h3>

                <p className="mt-0.5 text-[11px] leading-4 text-gray-400">
                  {item.description}
                </p>
              </div>

              <HiOutlineArrowNarrowRight size={17} className="-translate-x-1 shrink-0 text-gray-300 opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:text-purple-500 group-hover:opacity-100" />
            </button>
          ))}
        </div>
        
      </div>
    </aside>
  );
};

export default RightSide;